function Alerts() {
    return (
        <div className="Alerts"></div>
    );
}

export { Alerts };